import { Autocomplete, Box, FormControl, Grid, MenuItem, TextField, Typography, Checkbox } from "@mui/material";
import { CustomStyledTextField } from "./ColoredTextfield";
import { Controller } from "react-hook-form";
import { CustomStyledSelectField } from "./CustomStyledSelectField";

export default function LabeledSelectField({ label, width, multiline, disabled, onKeyUp, min, maxRows, alignItems, height, onChange, control, rules, callback, fontSize, labelStyle, name, endAdornment, textfieldStyles, options, madatory =false, optionValue ,...rest}) {
  const lowerLabel = label.toLowerCase();

  const getFieldValue = (fieldValue) => {
    if (lowerLabel === 'vessel') {
      return options?.find(
        (o) => o?.toLowerCase() === fieldValue?.toLowerCase()
      ) || fieldValue || "";
    }
    return fieldValue || "";
  };
    return (
    <FormControl sx={{  width:width || "100%",height:"100%",gap:0 }}>
      <Controller
       control={control}
       name={name}
       rules={rules}    
        render={({field,fieldState}) =>  <Grid container rowSpacing={label?"4px":0}>
        <Grid item xs={12}>
            <Typography style={{ textAlign: "start", fontFamily: "Figtree", ...labelStyle }}>{madatory ? (
              <>
                {label}
                <span style={{ color: "red", marginLeft: 4 }}>*</span>
              </>
            ) : (
              label
            )}</Typography>
        </Grid>
        {
            <TextField  select  sx={{...textfieldStyles , margin : 0}}  m={0} disabled={disabled}
        fullWidth size="small" color="primary" error={!!fieldState.error} helperText={fieldState.error?.message} {...field} value={getFieldValue(field.value)} variant="outlined" {...rest}  margin="normal"   
         onChange={(e)=>{
          if(callback){
            callback(e);
          }
          field.onChange(e);
        }}>
        {label.toLowerCase().includes('state') && (
          options?.map((r,i)=> {
              return   ( <MenuItem value={r.name + "/" + r.isoCode} key={i}>{r.name}</MenuItem>)
            })
        )
        }
              {['vessel', 'container type', 'service code', 'cargo type', 'commodity group', 'external pack', 'internal pack', 'currency', 'unit', 'vendor type', 'transport', 'vendor name', 'charge name', 'charge code' ,'vendor', 'term', 'nature of cargo', 'cargo movement','hbl type'].includes(label.toLowerCase()) && (
                options?.map((r, i) => {
                  return (<MenuItem value={r} key={i}>{r}</MenuItem>)
                })
              )
              }
        {
          label.toLowerCase() == 'carrier' && (
                  options?.map((r, i) => {
                    return (<MenuItem value={`${r['Display Name']} (${r['SCAC code']})`} key={i}>{`${r['Display Name']} (${r['SCAC code']})`}</MenuItem>)
                  })
          )
        }
              {
                label.toLowerCase() == 'mainline operator' && (
                  options?.map((r, i) => {
                    return (<MenuItem value={r.value} key={i}>{r.label}</MenuItem>)
                  })
                )
              }
        {/* {label.toLowerCase() === 'country*' && (
          options?.map((r,i)=> {
              return   ( <MenuItem value={r} key={i}>{r.name}</MenuItem>)
            })
        )
        } */}
        {(label.toLowerCase() === 'entity category*' || label.toLowerCase() === 'entity type*')    && (
            options?.map((r,i)=> {
              return   ( <MenuItem value={r} key={i}>{r}</MenuItem>)
            })
        )
        }
              {label.toLowerCase() !== 'state' && label.toLowerCase() !== 'entity category*' && !['vessel', 'container type', 'service code', 'cargo type', 'carrier', 'commodity group', 'external pack', 'internal pack', 'currency', 'unit', 'vendor type', 'transport', 'vendor name', 'charge name', 'charge code' ,'vendor', 'term', 'nature of cargo', 'cargo movement', 'hbl type'].includes(label.toLowerCase()) && (
            options?.map((r,i)=> {
              return   ( <MenuItem value={r.name} key={i}>{r.name}</MenuItem>)
            })
        )
        }
        </TextField>
        }
       </Grid>
     }
      />
        </FormControl>
     
    );
  }

export function LabeledMultiSelectField({ label, width, multiline, disabled, onKeyUp, min, maxRows, alignItems, height, onChange, control, rules, callback, fontSize, labelStyle, name, endAdornment, textfieldStyles, options, madatory = false, optionValue, multiple = false, ...rest }) {
  return (
    <FormControl
      sx={{
        width: width || "100%",
        height: "100%",
        gap: 0,
      }}
    >
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field, fieldState }) => (
          <Grid container rowSpacing={label ? "4px" : 0}>

            {/* Label */}
            <Grid item xs={12}>
              <Typography
                style={{
                  textAlign: "start",
                  fontFamily: "Figtree",
                  ...labelStyle,
                }}
              >
                {madatory ? (
                  <>
                    {label}
                    <span
                      style={{
                        color: "red",
                        marginLeft: 4,
                      }}
                    >
                      *
                    </span>
                  </>
                ) : (
                  label
                )}
              </Typography>
            </Grid>

            {/* Select */}
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                size="small"
                color="primary"
                variant="outlined"
                margin="normal"
                disabled={disabled}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                sx={{
                  ...textfieldStyles,
                  margin: 0,
                }}

                {...field}

                /* Important for multiple select */
                value={
                  multiple
                    ? Array.isArray(field.value)
                      ? field.value
                      : []
                    : field.value ?? ""
                }

                SelectProps={{
                  multiple: multiple,

                  renderValue: (selected) => {
                    if (!multiple) {
                      return selected;
                    }

                    return selected?.join(", ");
                  },
                }}

                onChange={(e) => {
                  const value = e.target.value;

                  if (callback) {
                    callback(e);
                  }

                  field.onChange(value);
                }}

                {...rest}
              >


                {/* ENTITY CATEGORY / TYPE */}
                {
                  options?.map((r, i) => (
                    <MenuItem value={r} key={i}>
                      {multiple && (
                        <Checkbox
                          checked={(field.value || []).includes(r)}
                        />
                      )}

                      {r}
                    </MenuItem>
                  ))}

                {/* {
                  options?.map((r, i) => {
                    const value = optionValue
                      ? r[optionValue]
                      : r.name;

                    return (
                      <MenuItem value={value} key={i}>
                        {multiple && (
                          <Checkbox
                            checked={(field.value || []).includes(value)}
                          />
                        )}

                        {r.name}
                      </MenuItem>
                    );
                  })} */}
              </TextField>
            </Grid>
          </Grid>
        )}
      />
    </FormControl>
  );
}

  
export function LabeledTextSelecField({ label, width, multiline, disabled, onKeyUp, min, maxRows, alignItems, height, onChange, control, rules, callback, fontSize, labelStyle, name, endAdornment, textfieldStyles, options, madatory = false, optionValue, placeholder, ...rest }) {
  return (
    <FormControl sx={{ width: width || "100%", height: "100%", gap: 0 }}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field, fieldState }) => (
          <Grid container rowSpacing={label ? "4px" : 0}>
            <Grid item xs={12}>
              <Typography
                style={{ textAlign: "start", fontFamily: "Figtree", ...labelStyle }}
              >
                {madatory ? (
                  <>
                    {label}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </>
                ) : (
                  label
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                disabled={disabled}
                options={options || []}
                value={field.value || null}
                onChange={(event, newValue) => {
                  field.onChange(newValue);
                  if (callback) callback(newValue);
                }}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={placeholder}
                    variant="outlined"
                    size="small"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  />
                )}
                {...rest}
              />
            </Grid>
          </Grid>
        )}
      />
    </FormControl>

  );
}